import { queryClient } from '@/lib/query-client'

/** Query-key prefixes per domain; hooks build their keys on these so mutations invalidate the right set. */
export const QK = {
  profile: ['profile'] as const,
  properties: ['properties'] as const,
  tenants: ['tenants'] as const,
  leases: ['leases'] as const,
  payments: ['payments'] as const,
  rents: ['rents'] as const,
  dashboard: ['dashboard'] as const,
  agreements: ['agreements'] as const,
  maintenance: ['maintenance'] as const,
  notifications: ['notifications'] as const,
  subscription: ['subscription'] as const,
  flags: ['flags'] as const,
  geo: ['geo'] as const,
  appVersion: ['app-version'] as const,
}

/** Mirrors the mobile event bus: what each kind of change makes stale. */
export type DomainEvent = 'property' | 'tenant' | 'payment' | 'profile' | 'agreement' | 'maintenance' | 'notification' | 'subscription' | 'viewCountry'

export const EVENT_INVALIDATIONS: Record<DomainEvent, (readonly string[])[]> = {
  property: [QK.properties, QK.dashboard],
  tenant: [QK.tenants, QK.leases, QK.dashboard],
  payment: [QK.payments, QK.rents, QK.leases, QK.dashboard],
  profile: [QK.profile, QK.dashboard],
  agreement: [QK.agreements, QK.leases],
  maintenance: [QK.maintenance, QK.leases, QK.dashboard],
  notification: [QK.notifications],
  subscription: [QK.subscription, QK.dashboard],
  // The viewing country scopes every combined figure and is the default of every list filter (LP-491).
  viewCountry: [QK.profile, QK.dashboard, QK.properties, QK.leases, QK.payments, QK.rents, QK.tenants],
}

export function invalidateFor(...events: DomainEvent[]): Promise<void[]> {
  const keys = new Set<readonly string[]>()
  events.forEach((e) => EVENT_INVALIDATIONS[e].forEach((k) => keys.add(k)))
  return Promise.all([...keys].map((queryKey) => queryClient.invalidateQueries({ queryKey })))
}
